import * as React from 'react';
import { memo } from 'react';
const SvgThicknessMedium = (props) => (
  <svg width={168} height={128} viewBox="0 0 168 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-68.6016 87.3332L132.548 -108.199L-62.9841 92.9507L-68.6016 87.3332ZM153.071 -87.5112L-48.0793 108.015L-42.4618 113.639L153.071 -87.5112ZM-27.398 128.537L173.752 -66.9957L-21.7739 134.154L-27.398 128.537ZM-6.79459 149.138L194.355 -46.3939L-1.17048 154.756L-6.79459 149.138ZM235.566 -5.18365L34.4157 190.342L40.0332 195.966L235.566 -5.18365ZM13.8122 169.74L214.962 -25.7854L19.4297 175.365L13.8122 169.74ZM276.769 36.0199L75.6192 231.552L81.2367 237.17L276.769 36.0199ZM55.0158 210.944L256.166 15.4181L60.6333 216.568L55.0158 210.944Z"
      fill="#51574E"
    />
  </svg>
);
const Memo = memo(SvgThicknessMedium);
export default Memo;
